import { Path } from "app/path";
import { clearCart } from "app/redux/cartSlice";
import { useQuery } from "app/utils/useQuery";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { generatePath, useNavigate, useParams } from "react-router-dom";

// Lets a customer swap the service they picked. The chosen time and barber depend
// on the service, so the booking starts over from the service list with an empty
// cart. A reschedule keeps its token so it still replaces the original booking.
export const useChangeService = () => {
  const { nameKey, shopKey }: any = useParams();
  const query = useQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useCallback(() => {
    dispatch(clearCart());

    const next = new URLSearchParams();
    const reschedule = query.get("appointmentGroupToReschedule");
    if (reschedule) next.set("appointmentGroupToReschedule", reschedule);

    const serviceUrl = generatePath(Path.BOOK_SERVICE, { nameKey, shopKey } as any);
    const search = next.toString();
    navigate(search ? `${serviceUrl}?${search}` : serviceUrl);
  }, [dispatch, navigate, nameKey, shopKey, query]);
};
